import { useEffect, useState } from 'react'
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom'
import AllPage from './pages/AllPage.jsx'
import MyPage from './pages/MyPage.jsx'
import ProfilePage from './pages/ProfilePage.jsx'
import VenueDetailPage from './pages/VenueDetailPage.jsx'
import PollTemplatesPage from './pages/PollTemplatesPage.jsx'
import MessageTemplatesPage from './pages/MessageTemplatesPage.jsx'
import SettingsPage from './pages/SettingsPage.jsx'
import UserSettingsPage from './pages/UserSettingsPage.jsx'
import InlinePollActionPage from './pages/InlinePollActionPage.jsx'
import ManualEventsPage from './pages/ManualEventsPage.jsx'
import { expandApp, getStartParamToken } from './utils/telegram.js'
import { FRONTEND_VERSION } from './version.js'
import { getBackendVersion } from './utils/api.js'

const IconAll = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
  </svg>
)

const IconMy = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
)

const IconProfile = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
)

function NavBar() {
  const navigate = useNavigate()
  const location = useLocation()

  const tabs = [
    { path: '/', label: 'All', Icon: IconAll },
    { path: '/my', label: 'My', Icon: IconMy },
    { path: '/profile', label: 'Profile', Icon: IconProfile }
  ]

  return (
    <nav className="nav-tabs">
      {tabs.map(({ path, label, Icon }) => (
        <button
          key={path}
          className={`nav-tab ${location.pathname === path ? 'active' : ''}`}
          onClick={() => navigate(path)}
        >
          <Icon />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  )
}

export default function App() {
  const [backendVersion, setBackendVersion] = useState('unknown')

  useEffect(() => {
    expandApp()
  }, [])

  useEffect(() => {
    let mounted = true
    getBackendVersion()
      .then((response) => {
        if (mounted) {
          setBackendVersion(response?.data?.backendVersion || 'unknown')
        }
      })
      .catch(() => {
        if (mounted) {
          setBackendVersion('unknown')
        }
      })

    return () => {
      mounted = false
    }
  }, [])

  return (
    <BrowserRouter>
      <NavBar />
      <div className="app-container">
        <p className="app-version-label">When? (frontend {FRONTEND_VERSION}, backend {backendVersion})</p>
        <Routes>
          <Route path="/" element={getStartParamToken() ? <InlinePollActionPage /> : <AllPage />} />
          <Route path="/inline-poll" element={<InlinePollActionPage />} />
          <Route path="/my" element={<MyPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/venue/:venueId" element={<VenueDetailPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/settings/poll-templates" element={<PollTemplatesPage />} />
          <Route path="/settings/message-templates" element={<MessageTemplatesPage />} />
          <Route path="/settings/user-preferences" element={<UserSettingsPage />} />
          <Route path="/settings/manual-events" element={<ManualEventsPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  )
}
